import { getCityInfo } from '@/pages/chargermap/utils/gis'
import cityCode from '@/pages/mapTool/config/cityCode'
import { defineComponent, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getLocation, getSummary } from '../../apis/map.api'
import { Point } from '../../contract/map'
import { useComponentStore } from '../../nsh5/localStores/component'
import NextPreview from '../nextPreview'

export default defineComponent({
  name: 'auto-display',
  emits: ['swipe'],
  setup: (props, { emit }) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const previewConfigList = ref(componentsConfig?.auto_zoom?.properties?.preview)
    if (!previewConfigList.value || previewConfigList.value.length !== 3) {
      return () => null
    }
    // const bus = useBus()
    // const appStore = useAppStore()
    const componentStore = useComponentStore()
    const previewIndex = ref<number>(0)
    const skipCityPreview = ref<number>(-1) // -1: 未完成  0: 不跳过  1: 跳过
    const router = useRouter()
    let currentCityCode = ''
    let onlyCountryMap = false // 只有显示全国的一幕

    const checkCanPreviewCity = async (loc: Point | null) => {
      // 1. 是否能获取到定位
      if (loc && loc.lat && loc.lng) {
        const res = await getLocation({
          lng: loc.lng,
          lat: loc.lat,
        }, 'autoDisplay')
        if (res.isValid()) {
          let tempCode = res.data.code
          if (Object.prototype.hasOwnProperty.call(cityCode, tempCode)) {
            currentCityCode = tempCode
          } else {
            tempCode = tempCode?.slice(0, 4) + '00'
            if (Object.prototype.hasOwnProperty.call(cityCode, tempCode)) {
              currentCityCode = tempCode
            } else {
              skipCityPreview.value = 1
              return
            }
          }
          // 2. 是否在显示city的白名单里面
          if (
            componentsConfig?.auto_zoom?.properties?.white_list?.includes('all') ||
            componentsConfig?.auto_zoom?.properties?.white_list?.includes(currentCityCode)
          ) {
            const summaryRes = await getSummary(currentCityCode, loc.lng, loc.lat, 'region')
            // 3. 是否在城市范围内有换电站
            if (summaryRes.isValid()) {
              const num = Number(summaryRes.data.swapNumber)
              if (num > 0) {
                skipCityPreview.value = 0
              } else {
                skipCityPreview.value = 1
              }
            } else {
              skipCityPreview.value = 1
            }
          } else {
            skipCityPreview.value = 1
          }
        } else {
          skipCityPreview.value = 1
        }
      } else {
        console.log('====================================')
        console.log('获取定位失败')
        console.log('====================================')
        skipCityPreview.value = 1
      }
      onlyCountryMap = skipCityPreview.value == 1
    }

    watch(
      () => skipCityPreview.value,
      () => {
        if (skipCityPreview.value === 1) {
          // 跳过区域
          if (componentsConfig?.swipe_component?.show) {
            // 若配置了视频，title要显示视频的title
            previewConfigList.value[0].title = previewConfigList.value[1].title
            previewConfigList.value[0].url = previewConfigList.value[1].url
          } else {
            // 若没有配置视频
            previewConfigList.value[0].title = previewConfigList.value[2].title
            previewConfigList.value[0].url = previewConfigList.value[2].url
          }
        } else {
          // 不跳过区域
          if (componentsConfig?.swipe_component?.show) {
            // 正常进行
          } else {
            // 若没有配置了视频
            previewConfigList.value[1].title = previewConfigList.value[2].title
            previewConfigList.value[1].url = previewConfigList.value[2].url
          }
        }
      }
    )

    const getSimple = () => {
      const selectCity = {} as {
        simple: string
        name: string
      }
      if (Object.prototype.hasOwnProperty.call(cityCode, currentCityCode)) {
        selectCity['simple'] = cityCode[currentCityCode].simple
        selectCity['name'] = cityCode[currentCityCode].city
        if (currentCityCode.lastIndexOf('00') === 4) {
          componentStore.$patch({ dimension: '市' })
        } else {
          componentStore.$patch({ dimension: '区县' })
        }
      } else {
        const tempCode = currentCityCode?.slice(0, 4) + '00'
        if (Object.prototype.hasOwnProperty.call(cityCode, tempCode)) {
          selectCity['simple'] = cityCode[tempCode].simple
          selectCity['name'] = '全部'
          componentStore.$patch({ dimension: '市' })
        }
      }
      return selectCity
    }

    const countDownStop = () => {
      switch (previewIndex.value) {
        case 0:
          if (skipCityPreview.value === 1) {
            // 跳过城市预览
            previewIndex.value = 2
            emit('swipe')
          } else {
            previewIndex.value++
            // 展示城市预览
            componentStore.bus.emit('hideSummary')
            const cityInfo = getSimple()
            componentStore.bus.emit('selectCity', getCityInfo(cityInfo.simple))
            setTimeout(() => {
              window.backHistoryNum++
              router.push({
                name: 'data_summary',
                state: {
                  backHistoryNum: window.backHistoryNum,
                },
              })
            }, 2500)
          }
          break
        case 1:
          if (componentsConfig?.swipe_component?.show) {
            previewIndex.value++
            emit('swipe')
          } else {
            previewIndex.value = 0
          }
          break
        case 2:
          previewIndex.value = 0
          break

        default:
          break
      }
    }
    watch(
      () => previewIndex.value,
      () => {
        if (previewIndex.value == 0) {
          // router.go(-1)
          setTimeout(() => {
            componentStore.bus.emit('goBackHome')
            componentStore.bus.emit('goBackHomeXinfa')
          }, 1000)
        }
      }
    )

    componentStore.bus.on('checkCanPreviewCity', (loc: Point | null) => {
      checkCanPreviewCity(loc)
    })
    onUnmounted(() => {
      componentStore.bus.off('videoDuration')
      componentStore.bus.off('checkCanPreviewCity')
    })

    return () => (
      <>
        <div>{skipCityPreview.value}</div>
        {onlyCountryMap && !componentsConfig?.swipe_component?.show ? null : (
          <>
            {skipCityPreview.value > -1 && (
              <NextPreview
                showTime={
                  componentsConfig?.auto_zoom?.properties?.show_time >= 0
                    ? componentsConfig?.auto_zoom?.properties?.show_time
                    : -1
                }
                config={previewConfigList.value[previewIndex.value]}
                onStop={countDownStop}
                previewIndex={previewIndex.value}
              ></NextPreview>
            )}
          </>
        )}
      </>
    )
  },
})
